import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { longDateTimeFormat } from './utils';

/* eslint-disable import/prefer-default-export */
export const tableOptions = {
  filterType: 'multiselect',
  selectableRows: 'none',
  responsive: 'standard',
  rowsPerPageOptions: [10, 20, 100],
  sortableFilterList: true,
};

/**
 *
 * @param searchQuery - string entered by user as search term to table
 * @param currentRow -- currentRow
 * @returns {Boolean} - true if searchQuery is in row
 */
export function isAMatchOrPhoneMatch(searchQuery, currentRow) {
  // mostly for use on the user table.
  // allow phone number search to work even
  // if the searchQuery contains non-numbers
  // like ( ) or -
  let match = false;
  const searchTerm = searchQuery.toLowerCase();
  currentRow.forEach((cell, index) => {
    // columns to allow search on are
    // only firstName, lastName and phone.
    // columns 1 - 3.
    // index of phoneNumber
    if (index === 0 || index > 4) return;
    const lowerCase = cell.toLowerCase();
    if (index === 4) {
      const numSearch = searchTerm.replace(/\D/g, '');
      if (numSearch) match = lowerCase.includes(numSearch);
    }

    const exactMatch = lowerCase.includes(searchTerm);
    if (exactMatch) match = true;
  });
  return match;
}

/**
 *
 * @param date: some Date to compare to filters
 * @param filters -- Array of after and before date range filter selections.
 * @returns {Boolean} - True excludes date from display
 */
export function shouldExcludeDate(date, filters) {
  // when user selects a filter
  // but the thing you are looking at doesn't have that date
  // exclude from display
  if (!isEmpty(filters) && !date) return true;
  const beforeFilter = filters[0];
  const afterFilter = filters[1];

  const isBefore = beforeFilter && moment(date).isBefore(moment(beforeFilter));
  const isAfter = afterFilter && moment(date).isAfter(moment(afterFilter));
  // when user selects both date filters (after and before)
  if (beforeFilter && afterFilter) {
    // exclude date if outside of either
    return isBefore || isAfter;
  } else if (beforeFilter) {
    // or if its before the first filter (the after filter)
    return isBefore;
  } else if (afterFilter) {
    // or if its after the second filter (the before filter)
    return isAfter;
  }
  return false;
}

/**
 *
 * @param dates: user selected array of date filter options
 * dates[0] - when user says show me filterName's AFTER this date
 * dates[1] - when user says show me filterName's BEFORE this date
 * @param filterName -- Name for display on filter chip
 * @returns {String} - Complete text for date range filter chip
 */
export function filterChipText(dates, filterName) {
  const minTime = moment(dates[0]).format(longDateTimeFormat);
  const maxTime = moment(dates[1]).format(longDateTimeFormat);
  if (dates[0] && dates[1]) {
    // user entered both date options
    return `${filterName} After: ${minTime} and Before ${maxTime}`;
  } else if (dates[0]) {
    // user only entered the 'After' match
    return `${filterName} After: ${minTime}`;
  } else if (dates[1]) {
    // user only entered the 'Before' match
    return `${filterName} Before: ${maxTime}`;
  }
  return false;
}

/**
 *
 * @param data: all row and column data
 * @param colIndex - column currently being sorted
 * @param order -- sort order, 'asc' or 'desc'
 * @param dateColumns -- array containing indexes of date columns, which need special sorting
 * @returns {Array} - Sorted array, respecting date values
 */
export function customSortWithDates(data, colIndex, order, dateColumns) {
  return data.sort((a, b) => {
    const isDateColumn = dateColumns.includes(colIndex);
    if (isDateColumn) {
      if (!a.data[colIndex]) return 1;
      if (!b.data[colIndex]) return -1;
      return (new Date(a.data[colIndex]) < new Date(b.data[colIndex]) ? -1 : 1) * (order === 'desc' ? 1 : -1);
    } else {
      return (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1);
    }
  });
}

export function customFilterForMarket(marketIds, filters) {
  let isMatch = false;
  filters.forEach((fltr) => {
    if (!marketIds.includes(fltr)) {
      isMatch = true;
    } else {
      isMatch = false;
    }
  });
  return isMatch;
}

export const TASK_VEHICLE_TYPE_KEY = 'taskVehicleType';
export const TASK_VEHICLE_BRAND_KEY = 'taskVehicleBrand';

export const REPAIR_VEHICLE_TYPE_KEY = 'repairVehicleType';
export const REPAIR_VEHICLE_BRAND_KEY = 'repairVehicleBrand';

export const VEHICLE_STATUS_KEY = 'vehicleStatus';
export const VEHICLE_TYPE_KEY = 'vehicleType';
export const VEHICLE_BRAND_KEY = 'vehicleBrand';

export const VEHICLES_TABLE_TITLE = 'Vehicles';
export const VEHICLES_CSV_COLUMN_NAME = 'Shortcode';
